import { useTranslation } from "react-i18next";
import clsx from "clsx";

import { LegalLinks } from "@root/constants.ts";

import { siteLink } from "@/helpers";

const CheckoutFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="mt-auto w-full">
      <div
        className={clsx(
          "w-full px-8px pt-32px pb-40px",
          "space-y-4px bg-[#FAFAFA]",
        )}
      >
        <div className="py-[6px]">
          <div className="text-center">
            <p className="text-[12px] text-dark-blueberry font-mabry-pro-regular leading-[24px]">
              {t("discover.footerCopy.research")}
            </p>
          </div>

          <div className="text-center">
            <p className="text-[12px] text-dark-blueberry font-mabry-pro-regular leading-[24px]">
              &copy;{t("footer.copyright")}
            </p>
          </div>

          <div className="flex flex-wrap justify-center text-center items-center gap-[8px]">
            <a
              key={LegalLinks[0].url}
              href={siteLink(LegalLinks[0].url)}
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(
                "!pb-0 text-[10px] text-v1-gray-dark font-mabry-pro-regular leading-[24px]",
              )}
            >
              {t(LegalLinks[0].label)}
            </a>
            <div className="h-[10px] w-[1px] bg-[#b0b0b0]" />
            <a
              key={LegalLinks[1].url}
              href={siteLink(LegalLinks[1].url)}
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(
                "!pb-0 text-[10px] text-v1-gray-dark font-mabry-pro-regular leading-[24px]",
              )}
            >
              {t(LegalLinks[1].label)}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CheckoutFooter;
